import { type CosignContextProps } from '@cosign/components/useContextCosign'
import { Cosign } from '@cosign/Cosign'
import { STM_COUNTRY_CONFIG } from '../constants'
import { useCountryCode } from '../hooks'
import { intellectualLinkMap, merchantCustomerServiceLinkMap, privacypoliciesLinkMap } from './linkMaps'

interface StmLoginProps {
  basePath: string
}

export const StmLogin = ({ basePath }: StmLoginProps) => {
  const countryCode = useCountryCode()
  const countryConfig = STM_COUNTRY_CONFIG[countryCode]

  if (!countryConfig) return null

  const { defaultCampaignCode, defaultProjectCode } = countryConfig
  const baseUrl = `${window.location.origin}${basePath}`
  const tokenLoginUrl = `${baseUrl}/auth-processing`

  return (
    <Cosign
      title="Buygather"
      customLogo="STM"
      projectCode={defaultProjectCode as CosignContextProps['projectCode']}
      emailLogin={true}
      privacypoliciesLink={privacypoliciesLinkMap[defaultProjectCode]}
      intellectualLink={intellectualLinkMap[defaultProjectCode]}
      serverLink={merchantCustomerServiceLinkMap[defaultProjectCode]}
      environment="merchant"
      redirectUrl={`${baseUrl}/product-catalog`}
      fallbackUrl={`${baseUrl}/product-catalog`}
      tokenLoginUrl={tokenLoginUrl}
      routeMap={{
        merchant: `${basePath}/login`,
        login: `${basePath}/login`,
        passwordRegister: `${basePath}/password/register`,
        passwordChange: `${basePath}/password/change`,
        passwordReset: `${basePath}/password/reset`,
        passwordSuccess: `${basePath}/password/success`,
        bindPhone: `${basePath}/bind-phone`,
        editAccount: `${basePath}/my-account/edit-account`,
      }}
      campaignCode={defaultCampaignCode}
    />
  )
}
